import React from 'react'
import { useTranslation } from 'react-i18next';
import helpers from 'utils/helpers';
import { BsCaretDown,BsCaretUp,BsCaretUpFill,BsCaretDownFill    } from "react-icons/bs";
function OTableHead({ sort, name, fieldName, setSort, classTd,tableClass }) {
  const { t } = useTranslation();
  return (
    helpers.ternaryCondition(fieldName,  <th
      scope="col"
      className="py-3 px-3 cursor-pointer"
      onClick={() => {
        if (sort?.sortKey === fieldName && sort?.sortType === "asc") {
          setSort({
            sortKey: fieldName,
            sortType: "desc",
          });
        } else {
          setSort({
            sortKey: fieldName,
            sortType: "asc",
          });
        }
      }}
    >
      <div className={`flex  ${classTd || ''}`}>
        <span className=''>{t(name)}</span>
        <span className='mx-1'>
          {helpers.ternaryCondition(helpers.andOperator(sort?.sortKey === fieldName,sort?.sortType === "asc"),<BsCaretUpFill size={'8px'}/>,<BsCaretUp size={'8px'} style={{color: sort?.sortKey === fieldName?'':'#1e202480'}}/>)}
          {helpers.ternaryCondition(helpers.andOperator(sort?.sortKey === fieldName, sort?.sortType === "desc"), <BsCaretDownFill size={'8px'}/>,<BsCaretDown size={'8px'} style={{color: sort?.sortKey === fieldName?'':'#1e202480'}}/>)}
        </span>
      </div>
    </th>, <th scope="col"
        className={`py-3 px-3 ${tableClass||''}`}>
        {t(name)}
      </th>
    )
  )
}

export default OTableHead